import { z } from "zod";

export const SupportCaseAttachmentItemSchema = z.object({
  Id: z.string().uuid(),
  FileName: z.string(),
  FileSize: z.number().optional(),
  MimeType: z.string().optional(),
});

export type SupportCaseAttachmentItemType = z.infer<
  typeof SupportCaseAttachmentItemSchema
>;
